/**
 * CharacterFilterBar — "Show <Character>'s Story". Multi-select toggle
 * chips; selecting mutes everything unrelated on the canvas rather than
 * hiding it (see boardHelpers.computeHighlightSet).
 */

import React from 'react';
import { Users, X } from 'lucide-react';
import { cx } from '@/components/site/primitives';

export default function CharacterFilterBar({ characters, selectedIds, onToggle, onClear }) {
  if (!characters.length) return null;

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <span className="flex items-center gap-1 text-xs font-semibold uppercase tracking-wide text-subtle">
        <Users className="h-3.5 w-3.5" /> Show story:
      </span>
      {characters.map((c) => {
        const active = selectedIds.includes(c.id);
        return (
          <button
            key={c.id}
            type="button"
            onClick={() => onToggle(c.id)}
            className={cx(
              'rounded-full border px-3 py-1 text-xs font-semibold transition-colors',
              active ? 'border-coral bg-coral/10 text-coral' : 'border-line text-subtle hover:border-coral/40 hover:text-ink'
            )}
          >
            {c.title}
          </button>
        );
      })}
      {selectedIds.length > 0 && (
        <button
          type="button"
          onClick={onClear}
          className="flex items-center gap-1 text-xs font-medium text-subtle hover:text-coral"
        >
          <X className="h-3 w-3" /> Clear
        </button>
      )}
    </div>
  );
}
